import React, {Fragment, forwardRef, useRef, useMemo, useEffect, useState} from 'react'
import _ from '/home/ps/root'
const Location = React.lazy(() => import('./location'))
const Route = React.lazy(() => import('./route'))
// const Cost = React.lazy(() => import('./cost'))
import { Loader } from "@googlemaps/js-api-loader"
// import overlay from './overlay'
// import Part from '../../part'
import { minutesToHoursAndMinutes, Ref, cache, Fields, promise, eId, cookies, copy } from '../../../global'
import { setPark } from '../../../io/'
// import Field from '../part/field'
// import {Fieldset} from '../part/group'
// import {Toast} from '../../../component/master/toast'
import '/home/ps/web/pub/map.css'
export const ID = 'map'
Ref[ID] = {}
const HTM = 'div'
const PROP = {className: ID}
const version = "weekly"
const option = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
}
const gps = (cb = e => {console.log('cb null', e);debugger}) => {
    navigator.geolocation.getCurrentPosition(e => {
    cb({lat: e.coords.latitude, lng: e.coords.longitude})
    console.log({ID, e}, 'install')
  }, e => console.log(ID, `ERROR(${e.code}): ${e.message}`), option)
}
const Maps = p => {
  const {param, vendor, cookie, lang, username, master} = p.master
  const park = prop.park
  // if (param.gps) debugger
  const shard = cookie.p
  const home = cookie.home
  const id = p.body?.id || ID
  // const db = p.db
  // const v = p.v
  const {db, v, renderMap, renderLocation} = p
  const pk = p.table.pk
  const cfgRow = p.row?.cfgRow
  const verb = p.row?.verb || 'default'
  const key = `${db}${v}${pk}${id}`
  const gId = id => `${key}${id||''}`
  let cfgLocation;
  try {
    cfgLocation = cfgRow && !Array.isArray(cfgRow) && JSON.parse(cfgRow.map)
  } catch (e) {debugger}
  const [cfgMap, _setCfgMap] = useState(cfgLocation || {})
  const setCfgMap = cfgMap => {
    _setCfgMap(cfgMap)
    addressUpdate(cfgMap)
    console.log(cfgMap)
  }
  // const mapKey = cfgRow && cfgRow[`${_.MAP}${_.KEY}`]
  // const mapKey = vendor[_.MAP+_.KEY]
  const [_toggle, setToggle] = useState()
  const toggle = () => p.toggle() & setToggle(!_toggle)
  const [order, setOrder] = useState()
  // const setOrder = s => _setOrder(_s => ({..._s, ...s}))
  const [state, _setState] = useState({position: {lat: null, lng: null}})
  const setState = s => _setState(_s => ({..._s, ...s}))
  const {map, directionsService, directionsRenderer, position} = state
  const [location, setLocation] = useState({})
  const [locationDetail, setLocationDetail] = useState('')
  const [routeDetail, setRouteDetail] = useState('')
  const [costDetail, setCostDetail] = useState()
  const [geoCode, setGeoCode] = useState({})
  const getGeoCode = request => {
    const {position, type, cb} = request
    const geoCoder = new google.maps.Geocoder()
    geoCoder.geocode({[type]: position}, (results, status) => cb && cb(results || status, request/*to collect json for store.php using tariq and rizwan buttons in location.js*/), e => {setLocationDetail(e);debugger})
  }
  const initialPosition = () => ({position, type: 'location'})
  const initialGeoCode = () => ({geometry: {location: position}, formatted_address: '', address_components: []})
  const reset = (
    _geoCode=initialGeoCode(),
    _location=initialPosition(),
  ) => {
    setGeoCode(_geoCode)
    setLocation(_location)
    // setRouteDetail()
    // setLocationDetail()
    // toggle()
    addressUpdate(_geoCode)
    console.log('reset', {_geoCode, _location})
  }

  const addressUpdate = _geoCode => {
    setGeoCode(_geoCode)
    let pin_code='', locality='', city='', state='', landmark=''
    _geoCode.address_components && _geoCode.address_components.map(component => {
      const types = component.types
      if (types.includes('postal_code')) pin_code = component.long_name
      if (types.includes('locality')) locality = component.long_name
      if (types.includes('administrative_area_level_2')) city = component.long_name
      if (types.includes('administrative_area_level_1')) state = component.long_name
      if (types.includes('point_of_interest')) landmark = component.long_name
    })
    eId(gId('search')).value = _geoCode.formatted_address
    eId(gId('address')).innerHTML = _geoCode.formatted_address
    eId(gId('pin_code')).innerHTML = pin_code
    eId(gId('locality')).innerHTML = locality
    eId(gId('city')).innerHTML = city
    eId(gId('state')).innerHTML = state
    eId(gId('landmark')).innerHTML = landmark
    eId(gId('name')).innerHTML = _geoCode.name ? (_geoCode.title || _geoCode.name) : ''
  }

  const getDirection = (cb, _markers=markers) => {
    if (_markers.length<2) return
    const routeConfig = _markers.reduce((acc, marker, i) => {
      const position = _markers[i].getPosition()
      if (i==0) acc.origin = position
      else if (i==_markers.length-1) acc.destination = position
      else acc.waypoints.push({location: position})
      return acc
    }, {
      travelMode: google.maps.TravelMode.DRIVING,
      avoidTolls: true,
      waypoints: [],
    })
    if (!routeConfig.destination) routeConfig.destination = routeConfig.origin
    // directionsService.route(routeConfig)
    //   .then((result, status) => directionsRenderer.getDirections(result) && cb(result || status))
    //   .catch(e => setRouteDetail(e.toString().split(':').pop()))
    directionsService.route(routeConfig, (result, status) => {
      console.log({ID, result, status})
      if (status=='OK') directionsRenderer.setDirections(result)
      if (cb) cb(result || status)
if (status!='OK') debugger
    }, e => setRouteDetail(e.toString().split(':').pop()))
  }

  const getMarker = geoCode => {
    const position = geoCode.geometry.location
    const marker = new google.maps.Marker({
    // const marker = new google.maps.AdvancedMarkerElement({
      position,//: geoCode.geometry.location,
      // map: markers.length==0 ? map : null,
      map,
      // clickable: true,
      label: geoCode.title || geoCode.formatted_address,
      // draggable: markers.length==0,
      draggable: !geoCode.map,
      // animation: null,
      // animation: google.maps.Animation.DROP,
      // animation: google.maps.Animation.BOUNCE,
      // title: 'Origin',
      // optimized: true,
      // zIndex: 5,
    })
    map.panTo(position)
    marker.index = markers.length//+1
    marker.geoCode = geoCode
// marker.addListener('click', e => animate(0, marker))
    // cb && cb(marker)
    // if (markers.length) setTimeout(() => map.setZoom(11), 2000)
    // const bounds = new google.maps.LatLngBounds()
    // markers.forEach(marker =>  bounds.extend(marker))
    // map.fitBounds(bounds)
    return marker
  }
  const [markers, _setMarkers] = useState([])
  const setMarkers = markers => _setMarkers(markers) & setSelect(markers.length-1)
  // const setRoute = geoCodes => {
  //   markers.forEach(m=>m.setMap(null))
  //   const _markers = geoCodes.reduce((acc, g, i) => {
  //     const init = g.init
  //     delete(g.init)
  //     const m = getMarker(g)
  //     Object.keys(init).forEach(k => {m[k] = init[k];debugger})
  //     m.setMap(map)
  //     acc.push(m)
  //     return acc
  //   }, [])
  //   // setMarkers([...m, ...markers])
  //   setMarkers(_markers)
  // }
  Ref[ID].route = markers
  // IO[ID].setRoute = setRoute

  const markersRemove = i => {
    markers.forEach(marker => marker.setMap(null))
    const m = [...markers]
    m.splice(i, 1)
    console.log({ID, m})
    m.forEach((marker, i) => marker.index = i)
    setMarkers(m)
    if (m.length==0) {
      addressUpdate(initialGeoCode())
      map.panTo(position)
      return reset()
    }
    if (m.length==1) {
      directionsRenderer.set('directions', null)
      m[0].index = 0
      m[0].setMap(map)
      map.panTo(m[0].getPosition())
      setTimeout(()=>map.setZoom(15), 1111)
      setSelect(0)
    }
  }

  const markersOrder = (i, dir='down') => {
    const move = dir=='down' ? 1 : -1
    const tmp = markers[i+move]
    console.log({tmp, move, markers})
    markers[i+move] = markers[i]
    markers[i] = tmp
    markers.forEach((marker, m) => marker.index = m)
    setMarkers(markers)
    getDirection(null, markers)
    // addressUpdate(markers[i].geoCode)
    // setSelect(i)
   // toggle()
    setOrder(!order)
    console.log({ID, i, select, dir, move, tmp, markers})
    // getDirection()
  }

  const [select, setSelect] = useState(markers.length)
  const setDirection = () => {
    const result = directionsRenderer.getDirections()
    if (!result) return setRouteDetail('none') // verified
    let dis=0, dur=0, i=0
if (result.routes.length>1)debugger
    result.routes.reduce((routes, route, r) => {
      if (markers.length != route.legs.length + 1) return
      route.legs.reduce((legs, leg, l) => {
        for (i=0; i<2; i++) { // 2 markers / leg
          markers[l+i].geoCode.formatted_address = i==0 ? leg.start_address : leg.end_address
          markers[l+i].setPosition(i==0 ? leg.start_location : leg.end_location)
          console.log({markers, leg, r, l, i}, markers[l+i].geoCode.formatted_address)
        }
        dis += leg.distance.value
        dur += leg.duration.value
        return legs
      }, [])
      // setRouteDetail(`${Math.round(dis)/1000} km , ${Math.round(dur/60)} min`)
      setRouteDetail(`${Math.round(dis)/1000} km , ${minutesToHoursAndMinutes(dur/60)}`)
      return routes
    }, [])
    // debugger
    // addressUpdate(markers[select].geoCode)
  }

  const animate = (i=0, marker=markers[i]) => {
    addressUpdate(marker.geoCode)
    if (markers.length==1) marker.setMap(map)
    // marker.setAnimation(marker.getAnimation()==null ? google.maps.Animation.BOUNCE : null)
    setSelect(i)
  }

  useEffect(() => {
// if (markers.length>1) debugger
    markers.forEach(marker => marker.setMap(null))
    if (directionsRenderer) {
      directionsRenderer.addListener('directions_changed', setDirection)
    }
    switch (markers.length) {
      case 0:
      break
      case 1:
      animate(0)
      break
      default:
      getDirection()
    }
    return () => {
      // directionsRenderer && directionsRenderer.removeListener && directionsRenderer.removeListener('directions_changed', setDirection)
      if (directionsRenderer && directionsRenderer.removeListener) {debugger
        directionsRenderer.removeListener('directions_changed', setDirection)
      }
    }
  }, [markers.length])

  useEffect(() => {
    if (geoCode.drag && markers.length==1) {
      const _geoCode = geoCode
// if (geoCode.drag) debugger
      delete(_geoCode.drag)
      markers[0].setMap(null)
      markers[0].geoCode = _geoCode
      markers[0].label = _geoCode.title || _geoCode.formatted_address
      setGeoCode(_geoCode)
      console.log({ID, geoCode, _geoCode, select}, markers[0])
      markers[0].setMap(map)
      // toggle()
    }
  }, [geoCode.drag])

  const createMap = () => {
    const map = new google.maps.Map(eId(gId('map')), {
      center: position,
      zoom: 15,
      // streetViewControl: false,
      // fullscreenControl: false,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        // style: google.maps.ZoomControlStyle.LARGE,
        // position: google.maps.ControlPosition.RIGHT_CENTER
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID]
      }, // here´s the array of controls
      disableDefaultUI: true, // a way to quickly hide all controls
      // mapTypeControl: true,
      // scaleControl: true,
      zoomControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    })
    // overlay(map, markers)
    setPark({[ID]: {[db]: {[v]: {[pk]: true}}}})
    const directionsService = new google.maps.DirectionsService()
    const directionsRenderer = new google.maps.DirectionsRenderer({
      map,
      // suppressMarkers: true,
      draggable: true,
    })
    // p.setMap({map, directionsService, directionsRenderer})
    setState({map, directionsService, directionsRenderer})
    console.log({ID, position, key: gId()}, 'install')
  }
  // let loader
  useEffect(() => {
    if (map) {
      if (p.master.origin) {
        setMarkers([getMarker(p.master.origin)])
        setTimeout(() => {
          gps(position => {
            setState({position})
            addressUpdate({geometry: {location: position}, formatted_address: '', address_components: []})
          })
        }, 2222)
      }
    } else {
      if (p.master.origin && p.master.origin.geometry) {
        setState({position: p.master.origin.geometry.location})
      }
    }
  }, [map, p.master.origin])
  useEffect(() => {// lat from undefined to value only once
    // if (param.gps && position.lat==null) gps(position => setState({position}))
    if (position.lat==null || map) return
    if (p.maps) {
      createMap()
      // if (p.master.param.from) debugger
    } else {
      // const maps = new Loader({apiKey: mapKey || _.MAPS, version})
      const maps = new Loader({apiKey: _.MAP_KEY, version})
      p.setMaps(maps)
      maps.load().then(async () => {
        const { Map } = await google.maps.importLibrary("maps")
        createMap()
        // if (p.master.param.from) debugger
      })
    }
    // const loader = new Loader({apiKey: mapKey || _.MAPS, version})
    // loader.load().then(async () => {
    //   const { Map } = await google.maps.importLibrary("maps")
    //   const map = new google.maps.Map(eId(gId('map')), {
    //     center: position,
    //     zoom: 15,
    //     // streetViewControl: false,
    //     // fullscreenControl: false,
    //     zoomControlOptions: {
    //       style: google.maps.ZoomControlStyle.SMALL,
    //       // style: google.maps.ZoomControlStyle.LARGE,
    //       // position: google.maps.ControlPosition.RIGHT_CENTER
    //       position: google.maps.ControlPosition.RIGHT_TOP
    //     },
    //     mapTypeControlOptions: {
    //       mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID]
    //     }, // here´s the array of controls
    //     disableDefaultUI: true, // a way to quickly hide all controls
    //     // mapTypeControl: true,
    //     // scaleControl: true,
    //     zoomControl: true,
    //     mapTypeId: google.maps.MapTypeId.ROADMAP,
    //   })
    //   // overlay(map, markers)
    //   setPark({[ID]: true})
    //   const directionsService = new google.maps.DirectionsService()
    //   const directionsRenderer = new google.maps.DirectionsRenderer({map, draggable: true});
    //   p.setMap({map, directionsService, directionsRenderer})
    //   setState({map, directionsService, directionsRenderer})
    //   console.log({ID, position}, 'install')
    // })
  })

  const pp = {
    ...p,
    gps,
    gId,
    cfgMap,
    setCfgMap,
    // mapKey,
    map,
    position,
    location,
    initialGeoCode,
    geoCode,
    setLocation,
    setLocationDetail,
    markers,
    setMarkers,
    markersRemove,
    markersOrder,
    getMarker,
    getGeoCode,
    setGeoCode,
    routeDetail,
    costDetail,
    locationDetail,
    addressUpdate,
    reset,
    toggle,
    _toggle,
    select,
    setSelect,
    setState,
    animate,
    order,
  }
  const mapImg = cfgMap.media
  const fpk = mapImg && mapImg.length ? mapImg[0] : 0
  let src, title
  if (fpk) {
    const f = park.media[db].default[fpk]
    src = `https://${home}.${_.DOMAIN}/usr/${db}/media/${f.uri}.${f.type}`
    title = f.title
  }
const date = new Date()
  return (
    <div>
      {
        renderMap && verb=='default' ? cfgMap.formatted_address : ''
      }
      <div id={gId('container')} className='container'>
        <div id={gId('map')} className='map'>
        {
          mapImg && mapImg.length ? (
            <img src={src} style={{width: '100%', height: '100%'}}/>
          ) : ''
        }
        {
          (!mapImg || mapImg.length==0) ? (
            <img src={`https://${shard}.${_.DOMAIN}/img/maps.jpg`} style={{width: '100%', height: '100%'}}/>
          ) : ''
        }
        </div>
      </div>
      <br/>
      {
        renderMap && verb!='default' ? (
          <input
            type='button'
            value={master.select.i}
            onClick={e => {
              // const url = `/${lang}/${username}/media?db=${db}&v=${v}&pk=${pk}&verb=${verb}&id=${id}&select=${1}&selected=${cfgMap.media || '[]'}`
              const url = `/${username}/media?lang=${lang}&db=${db}&v=${v}&pk=${pk}&verb=${verb}&id=${id}&select=${1}&selected=${cfgMap.media || '[]'}`
              p.singletonTab(e, url)
            }}
          />) : ''
      }
      {
        renderLocation ? [
          <Route {...pp} key='route'/>,
          // <Cost {...pp} key={_.COST}/>,
          <Location {...pp} key='location'/>
        ] : ''
      }
      {
        renderMap && cfgMap ? (
          <address>
            <br/>
            {
              verb=='default' ? (
                <a onClick={e => p.singletonTab(e, `http://maps.google.com/?q=${cfgMap.formatted_address}`)}>
                  Navigate
                  <br/>
                  <br/>
                  {cfgMap.formatted_address}
                </a>
              ) : ''
            }
            {
              verb!='default' ? <Location {...pp}/> : ''
            }
          </address>
        ) : ''
      }
    </div>
  )
}
Maps.ID = ID
export default Maps
// <address>
//   <br/><a href={`http://maps.google.com/?q=${denton}`}>Maps<br/>phone<br/>only chrome</a><br/>
//   <br/><a href="mailto:bytetrain@yahoo.com">Email<br/>our</a><br/>
//   <br/><a href="tel:+14372424644">Call<br/>phone<br/>only chrome</a><br/>
//   <br/><a href="text:+14372424644">Text<br/>our</a><br/>
// </address>


// window.addEventListener('message', e => {
//   console.log({ID, e})
//   if (e.origin !== "https://20.paksof.com") return
//   // debugger
// }, false)
